import { combineReducers } from 'redux';
import _isEmpty from 'lodash/isEmpty';
import _omit from 'lodash/omit';

import { hackDeepClone } from 'react-redux-app/lib/modules/core/utils';

import {
  ACTION_ADD_SITE_SEO_TRANSLATIONS,

  ACTION_DELETE_SEO_TRANSLATIONS__REQUEST,
  ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS,
  ACTION_DELETE_SEO_TRANSLATIONS__FAIL,

  ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__REQUEST,
  ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__SUCCESS,
  ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__FAIL,
} from '../actionTypes';


const data = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SITE_SEO_TRANSLATIONS:
      return action.payload.siteSeoTranslations;

    case ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__SUCCESS: {
      const { keys, lang } = action.payload;

      let newData = hackDeepClone(state);
      keys.forEach(key => {
        const keyWithTrans = _omit(state[key], lang);
        if (_isEmpty[keyWithTrans]) {
          newData = _omit(state, [key]);
        } else {
          newData[key] = keyWithTrans;
        }
      });

      return { ...newData };
    }

    case ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS:
      return _omit(state, action.payload.key);

    default:
      return state;
  }
};

const isBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_SEO_TRANSLATIONS__REQUEST:
      return { ...state, [action.payload.key]: true };

    case ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS:
    case ACTION_DELETE_SEO_TRANSLATIONS__FAIL:
      return _omit(state, action.payload.key);

    default:
      return state;
  }
};

const isBeingDeletedByLang = (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__REQUEST:
      return true;

    case ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__SUCCESS:
    case ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__FAIL:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  isBeingDeleted,
  isBeingDeletedByLang,
});
